/**
 *   Generated file. Do not edit
 */
import { TapResponse } from '@iotize/tap';
import { SERVICE_CALLS } from './service-calls';

import { AbstractService, ServiceCallType } from '@iotize/tap';

export class LteService extends AbstractService {
  public resources = SERVICE_CALLS;

  /**
   * Get LTE enable status
   *
   * LWM2M path: /1024//131
   *
   * @tapVersion(">=2.13")
   * @return
   */
  getEnabled(): Promise<TapResponse<boolean>> {
    return this.serviceCallRunner.execute(this.getEnabledCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//131
   *
   * @tapVersion(">=2.13")
   * @return call options
   */
  getEnabledCall(): ServiceCallType {
    const callOptions = { ...this.resources.getEnabled };

    return callOptions;
  }

  /**
   * Write LTE enable status
   *
   * LWM2M path: /1024//131
   *
   * @tapVersion(">=2.13")
   * @param isEnabled input
   * @return
   */
  putEnabled(
    /*
     *
     */
    isEnabled: boolean,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putEnabledCall(isEnabled));
  }

  /**
   *
   *
   * LWM2M path: /1024//131
   *
   * @tapVersion(">=2.13")
   * @param isEnabled input
   * @return call options
   */
  putEnabledCall(
    /*
     *
     */
    isEnabled: boolean,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putEnabled };

    callOptions.body = isEnabled;

    return callOptions;
  }

  /**
   * Get application data for LTE
   *
   * LWM2M path: /1024//122
   *
   * @tapVersion(">=2.11")
   * @return
   */
  getApplicationData(): Promise<TapResponse<number>> {
    return this.serviceCallRunner.execute(this.getApplicationDataCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//122
   *
   * @tapVersion(">=2.11")
   * @return call options
   */
  getApplicationDataCall(): ServiceCallType {
    const callOptions = { ...this.resources.getApplicationData };

    return callOptions;
  }

  /**
   * Set application data for LTE
   *
   * LWM2M path: /1024//122
   *
   * @tapVersion(">=2.11")
   * @param value input
   * @return
   */
  putApplicationData(
    /*
     *
     */
    value: Uint8Array,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putApplicationDataCall(value));
  }

  /**
   *
   *
   * LWM2M path: /1024//122
   *
   * @tapVersion(">=2.11")
   * @param value input
   * @return call options
   */
  putApplicationDataCall(
    /*
     *
     */
    value: Uint8Array,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putApplicationData };

    callOptions.body = value;

    return callOptions;
  }
}
